import React, { useState } from 'react';

import { useReactiveVar } from '@apollo/client/react';

import { ExportDocumentDialog, exportDocumentDialogVar } from './ExportDocumentDialog';
import { useInitiateDocxExport } from './useInitiateDocxExport';

export function ExportDocumentDialogContainer(): JSX.Element {
  const { open, pending } = useReactiveVar(exportDocumentDialogVar);
  const [loading, setLoading] = useState(false);
  const { initiateDocxExport } = useInitiateDocxExport();

  function handleClose(): void {
    exportDocumentDialogVar({ open: false, pending: null });
  }

  return (
    <ExportDocumentDialog
      loading={loading}
      open={open}
      onClose={handleClose}
      onExport={async commentsMode => {
        if (!pending) return;

        setLoading(true);
        try {
          await initiateDocxExport(
            pending.documentId,
            { docParts: pending.docParts, name: pending.name },
            { commentsMode }
          );
          handleClose();
        } finally {
          setLoading(false);
        }
      }}
    />
  );
}
